// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__2w8DC","title":"ClientInsurance_title__3_of9","itemText":"ClientInsurance_itemText__zxpe0"};